import React from 'react';
import { Box, IconButton } from '@mui/material';
import { SportEvent } from '../types/SportEventTypes';

interface EventActionsProps {
  event: SportEvent;
  onClipCreate: (event: SportEvent) => void;
  textColor?: string;
  onDebug?: (event: SportEvent) => void;
  /** Blocks clip creation, e.g. while the event has no video yet. */
  disabled?: boolean;
}

export const EventActions: React.FC<EventActionsProps> = ({
  event,
  textColor = 'rgba(255,255,255,0.6)',
  onDebug,
  onClipCreate,
  disabled,
}) => {
  const fillColor = event.clipGroupCount || 0 > 0 ? '#27272E' : textColor ? textColor : '#DBDBE1';
  const backgroundColor = event.clipGroupCount || 0 ? '#DBDBE1' : 'rgba(255, 255, 255, 0.11)';
  return (
    <Box
      sx={{
        display: 'flex',
        cursor: disabled ? 'default' : 'pointer',
        width: '48px',
        height: '32px',
        borderRadius: 0.5,
        px: 1.5,
        py: 0.5,
        backgroundColor,
        alignContent: 'center',
        justifyContent: 'center',
        '&:hover': {
          backgdouncColor: 'rgba(255, 255, 255, 0.22)',
        },
      }}
    >
      <IconButton
        size="medium"
        disableRipple
        disabled={disabled}
        sx={{
          color: textColor,
          '&:hover': {
            backgroundColor: 'transparent',
            '& svg path': {
              fill: fillColor,
            },
          },
        }}
        onClick={(e) => {
          e.stopPropagation();
          onClipCreate(event);
        }}
        title="Create clip"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.83952 3H18.1605C19.1776 3.00383 20.152 3.40687 20.8712 4.12125C21.5904 4.83563 21.9961 5.80344 22 6.81372V17.1863C22.0009 18.196 21.5981 19.1648 20.8802 19.8797L20.8444 19.912C20.1299 20.608 19.1694 20.9985 18.1686 21H5.83952C5.33556 20.9997 4.83662 20.9005 4.37131 20.7083C3.906 20.516 3.48347 20.2344 3.12793 19.8797L3.09538 19.8441C2.39362 19.135 2.00027 18.1806 2 17.1863L2 6.81372C2.00301 5.80318 2.40849 4.83488 3.12789 4.12031C3.84729 3.40575 4.82214 3.00299 5.83952 3ZM10.7891 10.7164L14.8988 13.5666C14.9843 13.6207 15.0551 13.6949 15.1049 13.7827C15.1546 13.8704 15.1819 13.969 15.1841 14.0698C15.1864 14.1705 15.1636 14.2702 15.1178 14.3601C15.072 14.4499 15.0046 14.5272 14.9215 14.5851L10.8249 17.3964C10.7152 17.4873 10.577 17.537 10.4342 17.5371C10.3528 17.5377 10.2721 17.5224 10.1967 17.4919C10.1213 17.4613 10.0527 17.4163 9.9949 17.3594C9.9371 17.3024 9.89122 17.2346 9.85992 17.16C9.82861 17.0853 9.8125 17.0052 9.8125 16.9244V11.2159C9.81097 11.1026 9.84129 10.9911 9.90004 10.8939C9.9588 10.7968 10.0437 10.7178 10.1451 10.6659C10.2466 10.614 10.3606 10.5912 10.4743 10.6002C10.5881 10.6091 10.6971 10.6493 10.7891 10.7164ZM3.19629 7.27932H5.47493L6.94954 4.18825H5.83952C5.13915 4.19038 4.46808 4.46768 3.97284 4.95959C3.47761 5.4515 3.19844 6.11806 3.19629 6.81372V7.27932ZM8.03027 4.18825L6.55729 7.27932H10.6849L12.1611 4.1931L8.03027 4.18825ZM13.2386 4.18825L11.7526 7.27932H15.7728L17.2506 4.18825H13.2386ZM18.3363 4.18825L16.8535 7.27932H20.8037V6.81372C20.8008 6.14732 20.5441 5.5067 20.0851 5.02058C19.6262 4.53445 18.9991 4.23883 18.3298 4.1931L18.3363 4.18825ZM20.8102 8.50153H3.19629V17.1863C3.19899 17.87 3.47059 18.5255 3.95312 19.0131L3.98079 19.039C4.47257 19.5316 5.14111 19.8101 5.83952 19.8134H18.1605C18.8477 19.8128 19.5075 19.546 19.9997 19.0697L20.0257 19.0406C20.2719 18.7979 20.4674 18.5093 20.6009 18.1914C20.7344 17.8734 20.8033 17.5324 20.8037 17.1879V8.50638L20.8102 8.50153Z"
            fill={fillColor}
          />
        </svg>
      </IconButton>
    </Box>
  );
};
